export default {
  allFiles: [],
  viewFile: [],
  createdFiles: {},
  updatedFile: {},
  deletedFile: {},
  fileStoreage: "",
  picture: {},
};
